import React from 'react';
import { connect } from 'react-redux';
import ReactPaginate from 'react-paginate';
import { editando, limpiarFiltros } from '../../actions/generalActios';
import { getGrupoPlanes, getGrupoPlanesById } from '../../api/axios';
import {
    setId,
    setPlanes,
    fetchGrupoPlanes,
    fetchGrupoPlanesById,
    setPlanesDesdeBusqueda,
    setDataGrupoCopy,
    setDataGrupo,
    setFiltroGrupoPlanes
} from '../../actions/planesActions';
import PlanesListItem from './PlanesListItem';
import FiltroGrupoPlanes from './FiltroGrupoPlanes';
import BtnToggleFilter from "../General/Filter/BtnToggleFilter";
import BigSpinner from "../General/BigSpinner";
import { exportToExcel } from '../General/Excel/ExcelExportHelper';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

// Wrapper para usar hooks en class component
function ListPlanesWrapper(props) {
  const navigate = useNavigate();
  return <ListPlanes {...props} navigate={navigate} />;
}


class ListPlanes extends React.Component {

    toastXls = null;

    constructor(props) {
        super(props);
        this.state = {
            showFilter: this.props.filtro?.showFilter ?? false, 
            hideNoHay: false,
            listaGrupoPlanes: null,
            listaPlanesDeGrupos: null,
            datosExcelFormateados: null,
            isLoadingXls: false
        };
        //this.INITIAL_REQUEST = {
        //    descripcion: "",
        //    cantidadPagina: 10,
        //    numeroPagina: 1
        //};
        this.INITIAL_REQUEST = {
            descripcion: "",
            page: 1,
            pageSize: 10
        };
    };

    componentDidMount() {
        if (this.props.grupoPlanes?.length > 0) {
            return;
        } 
        if (this.props.isFilterClear) {
            this.buscarSinFiltro();
        } else {
            this.buscarConFiltro();
        }
    }
    
    buscarSinFiltro = () => {
        this.busquedaGrupoPlanes(this.INITIAL_REQUEST);
        this.props.setFiltroGrupoPlanes({ ...this.INITIAL_REQUEST, showFilter: this.state.showFilter });
        this.setState({ forcePage: 0 });
    }

    buscarConFiltro = () => {
        let params = {
            descripcion: this.props.filtro?.descripcion ?? "",
            pageSize: this.INITIAL_REQUEST.pageSize,
            page: 1,
        };
        // Si hay estado seleccionado, agregarlo como int
        if (typeof this.props.filtro?.estado === 'number') {
            params.estado = this.props.filtro.estado;
        }
        this.busquedaGrupoPlanes(params);
        this.props.setFiltroGrupoPlanes({ ...this.props.filtro, page: 1 });
        this.setState({ forcePage: 0 });
        if (this.props.isFilterClear) {
            this.setLimpiarFiltroFalse()
        }
    }

    onPlanesChange = (cantidad) => {
        if (cantidad > 0) this.setState({ hideNoHay: true });
        else this.setState({ hideNoHay: false });
    }

    busquedaGrupoPlanes = async (request) => {
        let params = request;
        await this.props.fetchGrupoPlanes({ params });
        if (this.props.userType.isAdminMod) {
           // this.busquedaGrupoPlanesParaExcel(params);
        }
    }

    busquedaGrupoPlanesParaExcel = () => {
        this.toastXls = toast.info("Generando archivo Excel...", {
            autoClose: false,
            hideProgressBar: true,
        });

        this.setState({ isLoadingXls: true });
        //const req = getGrupoPlanes({
        //    cantidadPagina: 500,
        //    numeroPagina: 1,
        //    descripcion: this.props.filtro?.descripcion ?? "",
        //});
        let request = {
            pageSize: 500,
            page: 1,
            descripcion: this.props.filtro?.descripcion ?? "",
        }

        const req = getGrupoPlanes(request);
        req.then(res => {
            this.setState({ listaGrupoPlanes: res.data.elementos });
            let listaPlanes = [];
            const cantidadTotalGrupos = res.data.cantidadTotal;

            for (let index = 0; index < res.data.cantidadTotal; index++) {

                const idGrupoPlan = res.data.elementos[index].idGrupoPlan;
                const req = getGrupoPlanesById({ idGrupoPlan: idGrupoPlan });
                req.then(res => {
                    if (typeof res != 'string') {
                        if (typeof res.data != 'string') {
                            res.data["planGrupo"] = index;
                            listaPlanes.push(res.data)
                            if (listaPlanes.length == cantidadTotalGrupos) {
                                this.setState({ listaPlanesDeGrupos: listaPlanes });
                                this.setDatosExcelFormateados();
                            }
                        }
                    }
                })

            }
        }).catch(err => { })
    }

    setDatosExcelFormateados = () => {
        const listaGrupoPlanes = this.state.listaGrupoPlanes;
        const listaPlanesDeGrupo = this.state.listaPlanesDeGrupos;
        let indexGrupo = 0;
        let indexPlanes = 0;
        let grupo = [];
        let listaGrupo = [];
        if (Array.isArray(listaPlanesDeGrupo)) {
            let porcent = 0;
            for (indexGrupo = 0; indexGrupo < listaGrupoPlanes.length; indexGrupo++) {
               
                for (indexPlanes = 0; indexPlanes < listaPlanesDeGrupo.length; indexPlanes++) {
                    if (listaPlanesDeGrupo[indexPlanes].planGrupo === indexGrupo) {
                        grupo = listaGrupoPlanes[indexGrupo];
                        grupo["planes"] = listaPlanesDeGrupo[indexPlanes];
                        listaGrupo.push(grupo);
                    }
                }
            }
        }
        let cambioPlanes = [];
        let c = 0;
        while (listaGrupo.length > c) {
            for (let i = 0; i < listaGrupo[c].planes.elementos.length; i++) {
                let cambioPlan = [];
                cambioPlan["comision"] = listaGrupo[c].comision;
                cambioPlan["descripcion"] = listaGrupo[c].descripcion;
                cambioPlan["idGrupoPlan"] = listaGrupo[c].idGrupoPlan;
                cambioPlan["numeroPlan"] = listaGrupo[c].planes.elementos[i].numeroPlan;
                cambioPlan["descripcionPlan"] = listaGrupo[c].planes.elementos[i].descripcion;
                cambioPlanes.push(cambioPlan);
            }
            c++;
        }

        this.setState({ datosExcelFormateados: cambioPlanes });
        this.setState({ isLoadingXls: false });

        this.botonDescarga.click();

        toast.update(this.toastXls, {
            render: "Descargando Archivo Excel ...",
            type: toast.TYPE.SUCCESS,
            autoClose: 3000,
            hideProgressBar: true,
        });
       
    }

    handlePageClick = (e) => {
        const selectedPage = e.selected + 1;
        //this.busquedaGrupoPlanes({
        //    descripcion: this.props.filtro?.descripcion ?? "",
        //    numeroPagina: selectedPage,
        //    cantidadPagina: this.INITIAL_REQUEST.cantidadPagina
        //});
        const params = {
            descripcion: this.props.filtro?.descripcion ?? "",
            page: selectedPage,
            pageSize: this.INITIAL_REQUEST.pageSize
        };
        if (typeof this.props.filtro?.estado === 'number') {
            params.estado = this.props.filtro.estado;
        }
        this.busquedaGrupoPlanes(params);
        this.props.setFiltroGrupoPlanes({ ...this.props.filtro, numeroPagina: selectedPage });
        if (this.props.isFilterClear) {
            this.setLimpiarFiltroFalse()
        }
    };

    setLimpiarFiltroFalse = () => {
        this.props.limpiarFiltros({ ...this.props.emptyFilters, grupoPlanes: false });
    }

    onGrupoPlan = (id) => {
        this.props.editando(true);
        this.props.setPlanesDesdeBusqueda([]);
        this.props.setDataGrupoCopy({})
        this.props.setPlanes([]);
        this.props.setId(id);
        this.props.navigate(`/Planes/Editar/${id}`);
    }

    goToPlanesNuevo = () => {
        this.props.fetchGrupoPlanesById({ idGrupoPlan: 0 });
        this.props.setDataGrupo({ descripcion: "", comision: "" });
        this.props.setPlanesDesdeBusqueda([]);
        this.props.setId(0);
        this.props.editando(false);
        setTimeout(() => { this.props.navigate("/Planes/Nuevo"); }, 500)
    }

    handleShowFilter = (value) => {
        this.setState({ showFilter: value });
        this.props.setFiltroGrupoPlanes({ ...this.props.filtro, showFilter: value });
    }

    render() {
        const { grupoPlanes } = this.props;

        return (
            <div className="container">
                <div className="row align-items-center justify-content-between page-titles">

                    <div className="col-4">
                        <h3 className="text-themecolor color-rojo-megatone">Grupos de Planes</h3>
                    </div>

                    <div className="button-group col-8 text-end">
                        {this.props.userType.isAdminMod && (
                            <>
                                {/* Botón para exportar los datos */}
                                <button
                                    type="button"
                                    //onClick={this.busquedaGrupoPlanesParaExcel(this.INITIAL_REQUEST)}
                                    onClick={() => this.busquedaGrupoPlanesParaExcel()}
                                    className="btn btn-sm btn-green"
                                    disabled={this.state.isLoadingXls}
                                >

                                Exportar a Excel
                                </button>

                                {/* Botón oculto para la descarga del archivo */}
                                <button
                                    style={{ display: "none" }}
                                    ref={(btn) => (this.botonDescarga = btn)}
                                    onClick={() => exportToExcel(this.state.datosExcelFormateados, 'Grupo Planes', 'grupoPlanes')}
                                />
                            </>
                        )}

                        <button
                            type="button"
                            onClick={this.goToPlanesNuevo}
                            className="btn btn-sm btn-green"
                        >
                            <i className="fa fa-plus-circle mx-1" /> Crear Grupo
                        </button>

                        <BtnToggleFilter
                            show={this.state.showFilter}
                            handleShow={() => this.handleShowFilter(!this.state.showFilter)}
                        />
                    </div>

                </div>

                <div hidden={!this.state.showFilter}>
                    <FiltroGrupoPlanes 
                        className="col-12"
                        getPlanes={this.buscarConFiltro}
                        clearFilter={this.buscarSinFiltro}
                    />
                </div>

                <div hidden={!this.state.hideNoHay}>
                    <h5 className="d-flex justify-content-center m-t-40 m-b-40">No hay grupo de planes</h5>
                </div>

                {this.props.isLoading ? <BigSpinner /> :
                    <>
                        {grupoPlanes &&
                            grupoPlanes.map((plan, i) => {
                                return (
                                    <div className="list-group" key={i}>
                                        <a
                                            onClick={e => {
                                                // Si el click fue sobre el switch, no navegar
                                                if (
                                                    e.target &&
                                                    e.target.classList &&
                                                    e.target.classList.contains('form-check-input')
                                                ) {
                                                    return;
                                                }
                                                this.onGrupoPlan(plan.idGrupoPlan);
                                            }}
                                        >
                                            <PlanesListItem
                                                idGrupo={plan.idGrupoPlan}
                                                nombre={plan.descripcion}
                                                cantidadPlanes={plan.cantidadDeTipoPlanes}
                                                comision={plan.comision}
                                                estado={plan.estado}
                                                filtro={this.props.filtro}
                                                onEstadoActualizado={this.buscarConFiltro}
                                            />
                                        </a>
                                    </div>
                                );
                            })
                        }
                    </>
                }

                <div className="d-flex justify-content-center">
                    <ReactPaginate
                        previousLabel={"Anterior"}
                        nextLabel={"Siguiente"}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={Math.ceil(this.props.cantidadTotal / 10)}
                        marginPagesDisplayed={10}
                        pageRangeDisplayed={10}
                        onPageChange={this.handlePageClick}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"}
                        forcePage={typeof this.props.page === 'number' ? this.props.page - 1 : 0}
                    />
                </div>
            </div>
        );
    }
}


const mapStateToProps = (state) => ({
    seller: state.general.idSeller,
    userType: state.general.userType,
    isLoading: state.planes.loadingPlanes,
    grupoPlanes: state.planes.grupoPlanes.elementos,
    cantidadTotal: state.planes.grupoPlanes.total,
    filtro: state.planes.filtro,
    page: state.planes.grupoPlanes.page, // <-- page del backend
    isFilterClear: state.general.limpiar.grupoPlanes,
    emptyFilters: state.general.limpiar,
});

export default connect(mapStateToProps, {
    setId,
    editando,
    setPlanes,
    setDataGrupo,
    setDataGrupoCopy,
    fetchGrupoPlanes,
    fetchGrupoPlanesById,
    setPlanesDesdeBusqueda,
    setFiltroGrupoPlanes,
    limpiarFiltros
})(ListPlanesWrapper);